var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCgnosis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Safe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6529 17.4489C12.2831 17.4489 12.8648 17.2389 13.3334 16.8755L9.4877 13.0312C9.12413 13.4916 8.9141 14.0731 8.9141 14.7111C8.906 16.2213 10.134 17.4489 11.6529 17.4489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0931 14.7033C23.0931 14.0734 22.8831 13.4919 22.5195 13.0234L18.6738 16.8677C19.1343 17.2311 19.716 17.4411 20.3543 17.4411C21.8651 17.4492 23.0931 16.2216 23.0931 14.7033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.0312 10.5273L23.3265 12.2314C23.8921 12.9098 24.2314 13.7659 24.2314 14.7189C24.2314 16.859 22.4944 18.5954 20.3534 18.5954C19.4082 18.5954 18.5437 18.2562 17.8651 17.6909L15.9988 19.5565L14.1325 17.6909C13.4539 18.2562 12.5975 18.5954 11.6441 18.5954C9.50319 18.5954 7.76623 16.859 7.76623 14.7189C7.76623 13.774 8.10553 12.9098 8.67108 12.2314L7.79849 11.3592L6.96639 10.5273C5.99689 12.1264 5.43945 13.992 5.43945 15.9949C5.43945 21.8259 10.1657 26.5423 15.9907 26.5423C21.8158 26.5423 26.542 21.8178 26.542 15.9949C26.5582 13.9839 26.0007 12.1183 25.0312 10.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.6338 8.71028C21.7191 6.69935 19.0045 5.43945 15.9991 5.43945C12.9937 5.43945 10.2872 6.69935 8.36435 8.71028C8.10584 8.9849 7.85539 9.27562 7.62109 9.57444L15.991 17.9413L24.361 9.56639C24.1509 9.27562 23.9005 8.97679 23.6338 8.71028ZM15.9991 6.81241C18.4713 6.81241 20.7658 7.76538 22.4866 9.50175L15.9991 15.9869L9.5116 9.50175C11.2405 7.76538 13.5269 6.81241 15.9991 6.81241Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgnosis);
export default __webpack_public_path__ + "static/media/cgnosis.ec9e0c4679bafa5ae3d6e0668254c8eb.svg";
export { ForwardRef as ReactComponent };